__turbopack_context__.v({
  "filter-footer--mobile": "SfmQLG_filter-footer--mobile",
  "filter-header": "SfmQLG_filter-header",
  "filter-header--mobile": "SfmQLG_filter-header--mobile",
  "form": "SfmQLG_form",
  "form--mobile": "SfmQLG_form--mobile",
});
